import React from 'react';
import { Lang } from 'shared/constants';
import { Modal } from 'src/components/design-system';

const ChecklistItemDeleteComponent = React.memo(function ChecklistItemDeleteComponent({
  open = false,
  lang = Lang.DELETE_CHECKLIST_ITEM_CONFIRMATION,
  deleteCheck = () => {},
  entity = null,
  categoryId = null,
  onFinish = () => {},
}) {
  const [isLoading, setLoadingState] = React.useState(false);

  const deleteAction = React.useCallback(async () => {
    setLoadingState(true);

    await deleteCheck({ categoryId, id: entity?.id });

    onFinish();
    setLoadingState(false);
  }, [categoryId, deleteCheck, entity?.id, onFinish]);

  const dismiss = React.useCallback(() => {
    onFinish();
  }, [onFinish]);

  return (
    <Modal
      title={lang.TITLE}
      open={open}
      onCancel={dismiss}
      onSubmit={deleteAction}
      cancelText={lang.DISMISS}
      submitText={lang.CONFIRM}
      loading={isLoading}
      submitDisabled={isLoading}
      submitDanger>
      <p>{lang.TEXT.replace('{name}', entity?.title ?? '')}</p>
    </Modal>
  );
});

export { ChecklistItemDeleteComponent };
